import "@wwg/ui/dist/index.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { Auth, LoginGuard } from "./auth";
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from "react-query";
import { UserProvider } from "./hooks/useUser";
import { ErrorModalProvider, reportApiError } from "./context/errorModal";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import Cookies from "js-cookie";
import env from "./environment";
import { loadAnalytics } from "utils/analytics";

loadAnalytics(env.segmentWriteKey);

if (env.environmentApp === "dev") {
  const script = document.createElement("script");
  script.src =
    "https://www.bugherd.com/sidebarv2.js?apikey=mm1apngastb81qexzrh6yg";
  script.async = true;
  document.head.appendChild(script);
}

// Every hook in src/hooks rejects on a non-ok response but almost none of them
// render that failure, so without these the app fails silently. Cache-level
// handlers catch all of them at once; queries only reach here after their
// retries are exhausted. Opt a call out with meta: { suppressErrorModal: true }
// when it already surfaces its own feedback.
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => reportApiError(error, query?.options?.meta),
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) =>
      reportApiError(error, mutation?.options?.meta),
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // keep data cached for 10 minutes unless invalidated earlier
    },
  },
});

var language = Cookies.get("language-code") || "en";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: require("./locales/en.json"),
      },
      es: {
        translation: require("./locales/es.json"),
      },
    },
    lng: language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    pluralSeparator: "_",
  });

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorModalProvider>
        <Auth.Provider>
          <LoginGuard>
            <UserProvider>
              <Router>
                <App />
              </Router>
            </UserProvider>
          </LoginGuard>
        </Auth.Provider>
      </ErrorModalProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
